import { render, staticRenderFns } from "./TheLayout.vue?vue&type=template&id=483f9a7c&scoped=true&"
import script from "./TheLayout.vue?vue&type=script&lang=js&"
export * from "./TheLayout.vue?vue&type=script&lang=js&"
import style0 from "./TheLayout.vue?vue&type=style&index=0&id=483f9a7c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "483f9a7c",
  null
  
)

export default component.exports